import React, { FC } from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';
import ProfileIcon from 'icons/Profile.icon';

import './BrokerAvatar.styles.scss';

type BrokerAvatarProps = {
  className?: string;
  brokerAvatarUrl?: string;
};

const BrokerAvatar: FC<BrokerAvatarProps> = ({
  className,
  brokerAvatarUrl,
}) => {
  const classes = classNames(
    'broker-avatar',
    { 'broker-avatar--empty': !brokerAvatarUrl },
    className,
  );

  if (!brokerAvatarUrl)
    return (
      <div className={classes}>
        <ProfileIcon strokeWidth={1} />
      </div>
    );

  return (
    <ResolveImage
      className={classes}
      asAvatar
      src={getImgUrl(brokerAvatarUrl, RESIZED_WIDTH[100])}
    />
  );
};

export default BrokerAvatar;
